var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, computed, observable } from 'mobx';
import { PersonaliaModels, FinancialModels, LegalModels, ResumeModels, MediaModels } from '../models/CheckpointModels';
import { CheckpointType } from '../models';
export class ReportStore {
    constructor({ network, userStore }) {
        this.hasCollectedCheckpoints = false;
        this.loading = false;
        this.initialDataLoaded = false;
        this.depersonalizedOrderInformation = null;
        this.userStore = userStore;
        this.network = network;
    }
    resetCheckpoints() {
        this.hasCollectedCheckpoints = false;
        this.archivedCheckpoints = [];
        this.nameAndNationalIdCheckpoint = undefined;
        this.nameChangeCheckpoint = undefined;
        this.driversLicenseCheckpoint = undefined;
        this.residentialAddressCheckpoint = undefined;
        this.residentialAddressHistoryCheckpoint = undefined;
        this.migrationCheckpoint = undefined;
        this.personalDebtCheckpoint = undefined;
        this.studentDebtCheckpoint = undefined;
        this.taxableIncomeCheckpoint = undefined;
        this.vehicleOwnershipCheckpoint = undefined;
        this.paymentDefaultCheckpoint = undefined;
        this.corporateEngagementCheckpoint = undefined;
        this.extendedCorporateEngagementMappingCheckpoint = undefined;
        this.seizureAttemptsCheckpoint = undefined;
        this.personalBankruptcyCheckpoint = undefined;
        this.propertyOwnershipCheckpoint = undefined;
        this.employmentCheckpoint = undefined;
        this.currentEmploymentCheckpoint = undefined;
        this.educationCheckpoint = undefined;
        this.referencesCheckpoint = undefined;
        this.otherMeritsCheckpoint = undefined;
        this.cohabitantsCheckpoint = undefined;
        this.banOnBusinessAcitvityCheckpoint = undefined;
        this.extendedFinancialMappingActivtyCheckpoint = undefined;
        this.publicTrusteeshipCheckpoint = undefined;
        this.soleproprietorshipCheckpoint = undefined;
        this.representationProhobition = undefined;
        this.beneficialOwnerCheckpoint = undefined;
        this.internetAndMediaCheckpoint = undefined;
        this.highestEducationCheckpoint = undefined;
    }
    isArchivedCheckpoint(checkpoint) {
        return checkpoint.archived;
    }
    assignToStoreProperties(order, checkpoint) {
        if (checkpoint === null)
            return null;
        switch (checkpoint.type) {
            case 'NameAndNationalId':
                this.nameAndNationalIdCheckpoint = new PersonaliaModels.NameAndNationalIdCheckpoint(checkpoint);
                break;
            case 'Children':
                this.childrenCheckpoint = new PersonaliaModels.ChildrenCheckpoint(checkpoint);
                break;
            case 'ResidentialAddresses':
                this.residentialAddressCheckpoint = new PersonaliaModels.ResidentialAddressCheckpoint(checkpoint);
                break;
            case 'Cohabitants':
                this.cohabitantsCheckpoint = new PersonaliaModels.CohabitantsCheckpoint(checkpoint);
                break;
            case 'PersonalDebt':
                this.personalDebtCheckpoint = new FinancialModels.PersonalDebtCheckpoint(checkpoint);
                break;
            case 'StudentDebt':
                this.studentDebtCheckpoint = new FinancialModels.StudentDebtCheckpoint(checkpoint);
                break;
            case 'PaymentDefault':
                this.paymentDefaultCheckpoint = new FinancialModels.PaymentDefaultCheckpoint(checkpoint);
                break;
            case 'SeizureAttempts':
                this.seizureAttemptsCheckpoint = new FinancialModels.SeizureAttemptsCheckpoint(checkpoint);
                break;
            case 'PersonalBankruptcy':
                this.personalBankruptcyCheckpoint = new FinancialModels.PersonalBankruptcyCheckpoint(checkpoint);
                break;
            case 'DistrictCourts':
                this.districtCourtsCheckpoint = new LegalModels.CourtCheckpoint(checkpoint);
                break;
            case 'CourtsOfAppeal':
                this.courtsofAppealCheckpoint = new LegalModels.CourtCheckpoint(checkpoint);
                break;
            case 'AdministrativeCourts':
                this.administrativeCourtsCheckpoint = new LegalModels.CourtCheckpoint(checkpoint);
                break;
            case 'SanctionsList':
                this.sanctionsListCheckpoint = new LegalModels.SanctionsListCheckpoint(checkpoint);
                break;
            case 'PoliticallyExposedPerson':
                this.pepListCheckpoint = new LegalModels.PEPCheckpoint(checkpoint);
                break;
            case 'DriversLicense':
                this.driversLicenseCheckpoint = new PersonaliaModels.DriversLicenseCheckpoint(checkpoint);
                break;
            case 'MaritalStatus':
                this.maritalStatusCheckpoint = new PersonaliaModels.MaritalStatusCheckpoint(checkpoint);
                break;
            case 'Migration':
                this.migrationCheckpoint = new PersonaliaModels.MigrationCheckpoint(checkpoint);
                break;
            case 'MilitaryService':
                this.militaryServiceCheckpoint = new PersonaliaModels.MilitaryServiceCheckpoint(checkpoint);
                break;
            case 'VehicleOwnership':
                this.vehicleOwnershipCheckpoint = new FinancialModels.VehicleOwnershipCheckpoint(checkpoint);
                break;
            case 'CorporateEngagement':
                this.corporateEngagementCheckpoint = new FinancialModels.CorporateEngagementCheckpoint(checkpoint);
                break;
            case CheckpointType.ExtendedCorporateEngagementMapping:
                this.extendedCorporateEngagementMappingCheckpoint = new FinancialModels.ExtendedCorporateEngagementMappingCheckpoint(checkpoint);
                break;
            case CheckpointType.BanOnBusinessActivity:
                this.banOnBusinessAcitvityCheckpoint = new FinancialModels.BanOnBusinessActivtyCheckpoint(checkpoint);
                break;
            case CheckpointType.ExtendedFinancialMapping:
                this.extendedFinancialMappingActivtyCheckpoint = new FinancialModels.ExtendedFinancialMappingActivtyCheckpoint(checkpoint);
                break;
            case 'NameChange':
                this.nameChangeCheckpoint = new PersonaliaModels.NameChangeCheckpoint(checkpoint);
                break;
            case 'HistoryResidentialAddresses':
                this.residentialAddressHistoryCheckpoint = new PersonaliaModels.ResidentialAddressHistoryCheckpoint(checkpoint);
                break;
            case 'TaxableIncomeTwoYears':
            case 'TaxableIncomeThreeYears':
            case 'TaxableIncomeFiveYears':
                this.taxableIncomeCheckpoint = new FinancialModels.TaxableIncomeCheckpoint(checkpoint);
                break;
            case 'TaxableIncomeTenYears':
                this.taxableIncomeCheckpoint = new FinancialModels.TaxableIncomeCheckpoint(checkpoint);
                break;
            case 'PropertyOwnership':
                this.propertyOwnershipCheckpoint = new FinancialModels.PropertyOwnershipCheckpoint(checkpoint);
                break;
            case CheckpointType.PublicTrusteeship:
                this.publicTrusteeshipCheckpoint = new FinancialModels.PublicTrusteeshipCheckpoint(checkpoint);
                break;
            case CheckpointType.RepresentationProhibition:
                this.representationProhobition = new FinancialModels.PublicTrusteeshipCheckpoint(checkpoint);
                break;
            case CheckpointType.BeneficialOwner:
                this.beneficialOwnerCheckpoint = new FinancialModels.BeneficialOwnerCheckpoint(checkpoint);
                break;
            case 'Employment':
                this.employmentCheckpoint = new ResumeModels.EmploymentCheckpoint(checkpoint);
                break;
            case 'CurrentEmployment':
                this.currentEmploymentCheckpoint = new ResumeModels.EmploymentCheckpoint(checkpoint);
                break;
            case 'HighestEducation':
                this.highestEducationCheckpoint = new ResumeModels.EducationCheckpoint(checkpoint);
                break;
            case 'Educations':
                this.educationCheckpoint = new ResumeModels.EducationCheckpoint(checkpoint);
                break;
            case 'ReferencePerson':
                this.referencesCheckpoint = new ResumeModels.ReferencesCheckpoint(checkpoint);
                break;
            case 'OtherMerits':
                this.otherMeritsCheckpoint = new ResumeModels.OtherMeritsCheckpoint(checkpoint);
                break;
            case 'SoleProprietorship':
                this.soleproprietorshipCheckpoint = new FinancialModels.SoleProprietorshipCheckpoint(checkpoint);
                break;
            case 'InternetAndMedia':
                this.internetAndMediaCheckpoint = new MediaModels.InternetAndMediaCheckpoint(checkpoint);
                break;
            default:
                break;
        }
    }
    changeLanguage() {
        const currentLanguage = this.userStore.user.language;
        if (currentLanguage !== 'English') {
            this.userStore.user.language = 'English';
        }
        else {
            this.userStore.user.language = 'Svenska';
        }
    }
    get showLanguageSwitch() {
        //Visa endast i förhandsgranskningen. Ej i de riktiga portalerna.
        return !this.userStore.user.companyId;
    }
    get hasCheckpointData() {
        return !this.order.isInternationalOrder && this.hasCollectedCheckpoints;
    }
}
__decorate([
    observable
], ReportStore.prototype, "loading", void 0);
__decorate([
    observable
], ReportStore.prototype, "section", void 0);
__decorate([
    observable
], ReportStore.prototype, "showInfoModal", void 0);
__decorate([
    observable
], ReportStore.prototype, "infoModalData", void 0);
__decorate([
    observable
], ReportStore.prototype, "initialDataLoaded", void 0);
__decorate([
    observable
], ReportStore.prototype, "order", void 0);
__decorate([
    observable
], ReportStore.prototype, "nameAndNationalIdCheckpoint", void 0);
__decorate([
    observable
], ReportStore.prototype, "nameChangeCheckpoint", void 0);
__decorate([
    observable
], ReportStore.prototype, "childrenCheckpoint", void 0);
__decorate([
    observable
], ReportStore.prototype, "driversLicenseCheckpoint", void 0);
__decorate([
    observable
], ReportStore.prototype, "residentialAddressCheckpoint", void 0);
__decorate([
    observable
], ReportStore.prototype, "residentialAddressHistoryCheckpoint", void 0);
__decorate([
    observable
], ReportStore.prototype, "maritalStatusCheckpoint", void 0);
__decorate([
    observable
], ReportStore.prototype, "migrationCheckpoint", void 0);
__decorate([
    observable
], ReportStore.prototype, "militaryServiceCheckpoint", void 0);
__decorate([
    observable
], ReportStore.prototype, "cohabitantsCheckpoint", void 0);
__decorate([
    observable
], ReportStore.prototype, "personalDebtCheckpoint", void 0);
__decorate([
    observable
], ReportStore.prototype, "studentDebtCheckpoint", void 0);
__decorate([
    observable
], ReportStore.prototype, "taxableIncomeCheckpoint", void 0);
__decorate([
    observable
], ReportStore.prototype, "vehicleOwnershipCheckpoint", void 0);
__decorate([
    observable
], ReportStore.prototype, "paymentDefaultCheckpoint", void 0);
__decorate([
    observable
], ReportStore.prototype, "corporateEngagementCheckpoint", void 0);
__decorate([
    observable
], ReportStore.prototype, "extendedCorporateEngagementMappingCheckpoint", void 0);
__decorate([
    observable
], ReportStore.prototype, "seizureAttemptsCheckpoint", void 0);
__decorate([
    observable
], ReportStore.prototype, "personalBankruptcyCheckpoint", void 0);
__decorate([
    observable
], ReportStore.prototype, "propertyOwnershipCheckpoint", void 0);
__decorate([
    observable
], ReportStore.prototype, "banOnBusinessAcitvityCheckpoint", void 0);
__decorate([
    observable
], ReportStore.prototype, "extendedFinancialMappingActivtyCheckpoint", void 0);
__decorate([
    observable
], ReportStore.prototype, "publicTrusteeshipCheckpoint", void 0);
__decorate([
    observable
], ReportStore.prototype, "soleproprietorshipCheckpoint", void 0);
__decorate([
    observable
], ReportStore.prototype, "representationProhobition", void 0);
__decorate([
    observable
], ReportStore.prototype, "beneficialOwnerCheckpoint", void 0);
__decorate([
    observable
], ReportStore.prototype, "districtCourtsCheckpoint", void 0);
__decorate([
    observable
], ReportStore.prototype, "courtsofAppealCheckpoint", void 0);
__decorate([
    observable
], ReportStore.prototype, "administrativeCourtsCheckpoint", void 0);
__decorate([
    observable
], ReportStore.prototype, "sanctionsListCheckpoint", void 0);
__decorate([
    observable
], ReportStore.prototype, "pepListCheckpoint", void 0);
__decorate([
    observable
], ReportStore.prototype, "employmentCheckpoint", void 0);
__decorate([
    observable
], ReportStore.prototype, "currentEmploymentCheckpoint", void 0);
__decorate([
    observable
], ReportStore.prototype, "educationCheckpoint", void 0);
__decorate([
    observable
], ReportStore.prototype, "highestEducationCheckpoint", void 0);
__decorate([
    observable
], ReportStore.prototype, "referencesCheckpoint", void 0);
__decorate([
    observable
], ReportStore.prototype, "otherMeritsCheckpoint", void 0);
__decorate([
    observable
], ReportStore.prototype, "internetAndMediaCheckpoint", void 0);
__decorate([
    observable
], ReportStore.prototype, "archivedCheckpoints", void 0);
__decorate([
    observable
], ReportStore.prototype, "activeReportPackages", void 0);
__decorate([
    observable
], ReportStore.prototype, "company", void 0);
__decorate([
    observable
], ReportStore.prototype, "reportPackageName", void 0);
__decorate([
    observable
], ReportStore.prototype, "isIDD", void 0);
__decorate([
    observable
], ReportStore.prototype, "depersonalizedOrderInformation", void 0);
__decorate([
    observable
], ReportStore.prototype, "partnerAddonName", void 0);
__decorate([
    action
], ReportStore.prototype, "resetCheckpoints", null);
__decorate([
    action
], ReportStore.prototype, "changeLanguage", null);
__decorate([
    computed
], ReportStore.prototype, "showLanguageSwitch", null);
__decorate([
    computed
], ReportStore.prototype, "hasCheckpointData", null);
